import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { TaskDashboardPage } from '@/features/tasks/dashboard/TaskDashboardPage';

export const Route = createFileRoute('/_app/tasks/dashboard')({ component: DashboardRoute });

/**
 * La vista «Cruscotto» e' **da scrivania**, come «Scheda» e «WBS».
 *
 * Cinque tessere, una tabella a sette colonne, un grafico e le card delle commesse su 390 punti
 * sarebbero una colonna sola di numeri senza il confronto che li rende leggibili. Sul telefono il
 * carico del gruppo lo da' gia' l'Agenda con «Il gruppo»: per questo la vista non compare in
 * `mobileViews.ts`, e chi ci arriva per URL non trova un vicolo cieco ma l'Agenda.
 */
function DashboardRoute() {
  const isMobile = useIsMobileShell();
  if (isMobile) return <Navigate to="/tasks" replace />;
  return <TaskDashboardPage />;
}
